import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { AppComponent } from './app.component';
import { provideZonelessChangeDetection, ErrorHandler } from '@angular/core';
import { GlobalErrorHandlerService } from './app/core/services/global-error-handler.service';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router'; // 👈 Importa esto
import { routes } from './app/app.routes'; // 👈 Importa tus rutas
import { SUPABASE_CONFIG } from '@libs/shared';
// @ts-ignore
import { environment } from './environments/environment';

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(),
    // Configuración vital del Router para Angular 21
    provideRouter(
      routes,
      withComponentInputBinding(), // Permite recibir parámetros de URL como @Input()
      withViewTransitions()        // Añade animaciones fluidas tipo App Nativa entre páginas
    ),
    { provide: SUPABASE_CONFIG, useValue: environment }
  ]
}).catch(err => console.error(err));